import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=9454661a"
import script from "./MainDialog.vue?vue&type=script&lang=js"
export * from "./MainDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports